import { render, staticRenderFns } from "./DigitalVotings.vue?vue&type=template&id=28903742"
import script from "./DigitalVotings.vue?vue&type=script&lang=js"
export * from "./DigitalVotings.vue?vue&type=script&lang=js"
import style0 from "./DigitalVotings.vue?vue&type=style&index=0&id=28903742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports